import React from 'react';
import { DivisionLine, EvaluationsBlockContainer } from './styled';
import TextHelper from '@/core/helpers/TextHelper';
import notEvaluationsIcon from '../../../../../../../assets/icons/not-evaluations-icon.svg';

interface IProps {
  evaluations?: any[];
  relatedCourse?: any;
}

const EvaluationsBlock = (props: IProps) => {
  const { evaluations, relatedCourse } = props;

  return (
    <EvaluationsBlockContainer>
      <p>Evaluaciones:</p>
      <div>
        {evaluations && (
          <>
            {evaluations?.length > 0 ? (
              <ul>
                {evaluations?.map((e: any, i: any) => (
                  <>
                    <li key={i}>
                      {TextHelper.capitalize(e?.name, false, true)} (
                      {e?.shortName}){' '}
                      {Number(e.value) === 0.01 && <span>NS</span>}
                      {Number(e.value) === 0.02 && <span>-</span>}
                      {Number(e.value) !== 0.01 && Number(e.value) !== 0.02 && (
                        <span>{parseInt(e?.value, 10)}</span>
                      )}
                    </li>
                    {i + 1 < evaluations.length && (
                      <DivisionLine
                        backgroundColor={
                          'var(--background-background-disabled)'
                        }
                        margin={'4px 0px 4px -23px'}
                      />
                    )}
                  </>
                ))}
              </ul>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '16px'
                }}
              >
                <span>
                  <img src={notEvaluationsIcon} alt="notEvaluationsIcon" />
                </span>
                <span>No tienes evaluaciones registradas</span>
              </div>
            )}
          </>
        )}
      </div>
      {relatedCourse && (
        <div className="relatedCourse">
          <DivisionLine
            backgroundColor={'var(--text-text-disabled)'}
            margin={'16px 0px'}
          />
          {relatedCourse?.title && (
            <p>{TextHelper.capitalize(relatedCourse?.title, false, true)}</p>
          )}
          <div>
            <ul>
              {relatedCourse?.evaluations?.map((e: any, i: any) => (
                <>
                  <li key={i}>
                    {TextHelper.capitalize(e?.name, false, true)} (
                    {e?.shortName}){' '}
                    {Number(e.value) === 0.01 && <span>NS</span>}
                    {Number(e.value) === 0.02 && <span>-</span>}
                    {Number(e.value) !== 0.01 && Number(e.value) !== 0.02 && (
                      <span>{parseInt(e?.value, 10)}</span>
                    )}
                  </li>

                  {i + 1 < relatedCourse?.evaluations?.length && (
                    <DivisionLine
                      backgroundColor={'var(--background-background-disabled)'}
                      margin={'4px 0px 4px -23px'}
                    />
                  )}
                </>
              ))}
            </ul>
          </div>
        </div>
      )}
    </EvaluationsBlockContainer>
  );
};

export default EvaluationsBlock;
